var exports = {
  "kL": "x31de4314--bbe75c--container",
  "DD": "x31de4314--bbe75c--title",
  "Fp": "x31de4314--bbe75c--link-container",
  "nf": "x31de4314--bbe75c--link",
  "hJ": "x31de4314--bbe75c--counter",
  "Om": "x31de4314--bbe75c--dot",
};

module.exports = exports;
